const wheelTypes = {
  public: "public",
  private: "private",
  clones: "clones",
  unlock: "unlock",
  main: "main",
};

export default wheelTypes;
